module.exports = __webpack_public_path__ + "img/services-08.cf9992e1.jpg";